var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "box",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showLeftClickPopup,
          expression: "showLeftClickPopup"
        }
      ],
      ref: "placeInfoBox",
      attrs: {
        background: "white",
        "no-border": "",
        closable: "",
        noTopBorder: "",
        customClass: "left-context-menu"
      },
      on: { closed: _vm.closePlaceInfo }
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v(_vm._s(_vm.placeInfoTitle))
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "placeInfoContainer",
          attrs: { slot: "content" },
          slot: "content"
        },
        [
          _vm.hasPlaceInfo && _vm.clickInsidePolygon
            ? [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("mapLeftClick.polygonArea")) +
                    ": "
                ),
                _c("b", [_vm._v(_vm._s(_vm.placeInfo.containerArea))]),
                _c("br")
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPlaceInfo && _vm.placeInfo.placeName
            ? [_c("b", [_vm._v(_vm._s(_vm.placeInfo.placeName))]), _c("br")]
            : _vm._e(),
          _vm._v(" "),
          _vm.hasPlaceInfo
            ? [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("global.units.lng")) +
                    ", " +
                    _vm._s(_vm.$t("global.units.lat")) +
                    ":\n        " +
                    _vm._s(_vm.placeInfo.latLng.lng.toFixed(6)) +
                    ", " +
                    _vm._s(_vm.placeInfo.latLng.lat.toFixed(6)) +
                    " "
                ),
                _c("br"),
                _vm._v(" "),
                _vm.placeInfo.customHtml
                  ? _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.placeInfo.customHtml) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.placeInfo.hideDirectionsTo
                  ? _c(
                      "v-btn",
                      {
                        directives: [
                          {
                            name: "smart-tooltip",
                            rawName: "v-smart-tooltip",
                            value: {
                              show: true,
                              text: _vm.$t(
                                "mapLeftClick.directionsToClickedPoint"
                              ),
                              position: _vm.$lowResolution ? "top" : "left",
                              dark: true,
                              saveClose: true,
                              name: "directionsToClickedPoint"
                            },
                            expression:
                              "{show: true, text: $t('mapLeftClick.directionsToClickedPoint'), position: $lowResolution? 'top' : 'left', dark: true, saveClose: true, name: 'directionsToClickedPoint'}"
                          }
                        ],
                        attrs: { flat: "", icon: "" },
                        on: {
                          click: function($event) {
                            return _vm.directionsToPoint(_vm.placeInfo)
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              title: _vm.$t(
                                "mapLeftClick.directionsToClickedPoint"
                              ),
                              color: "dark"
                            }
                          },
                          [_vm._v("directions")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a207d6c", { render: render, staticRenderFns: staticRenderFns })
  }
}